import React, { Component } from 'react'
import { connect } from 'react-redux'
import Card1 from './cards/Card1';

export class CatagoriesSections extends Component {
    // Mehsullar Menu.js-de bir defe yuklenir, burada yox (her kateqoriya ucun ayrica sorgu 429 xetasi verirdi)
    render() {
        const { productData, background_img, icon, catagories_title, id } = this.props;
        // console.log(productData);
        const filteredData = productData?.filter(data => data.catagories_id === id);
        return (
            <div id={id} className='flex flex-col  pt-[60px]'>
                <div className=' relative '>
                    <div className=' overflow-hidden '>
                        <img src={background_img} className='min-w-[1304px] h-[172px] rounded-[8px] ' />
                    </div>

                    <button className='bg-[#3E484F] p-[16px_64px] rounded-[8px] flex items-center justify-center gap-[10px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                     max-[600px]:p-[16px_24px] max-[724px]:w-[80%] '>
                        <img src={icon} className='w-[32px] h-[32px] max-[568px]:' />

                        <p className='font-[600] text-[32px] leading-[40px] text-[#fff] max-[700px]:text-[24px] '>{catagories_title}</p>
                    </button>
                </div>

                <div className='grid grid-cols-4  pt-[44px] gap-[36px]  max-[1200px]:pt-[48px] max-[724px]:pt-[36px] max-[1200px]:grid-cols-3 max-[1024px]:gap-[24px] max-[724px]:grid-cols-2 max-[768px]:gap-[16px] max-[380px]:grid-cols-1 max-[380px]:m-[0_auto] max-[380px]:p-[0px_12px]'>
                    {filteredData?.map((cat, j) => {
                        const langCode = localStorage.getItem('langCode');

                        return (
                            <Card1
                                key={j}
                                id={cat?.catagories_id}
                                products_title={langCode === 'az' ? cat?.title : cat?.title_en}
                                products_image={cat?.image_full_url}
                                price={cat?.price}
                                show_price={cat?.show_price !== false}
                                weight={langCode === 'az' ? cat?.weight : cat?.weight_en}
                                description={langCode === 'az' ? cat?.description : cat?.description_en}
                            />

                        )
                    })

                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    productData: state.Data.productData,
})

export default connect(mapStateToProps)(CatagoriesSections)